import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';
import { formulaSetVersionNoScriptDto } from '../formula';

export const measurementPreviewDto = z.object({
  id: z.string(),
  timestamp: z.date(),
  timestampCalculation: z.date().nullable(),
  formulaSetVersion: formulaSetVersionNoScriptDto.nullable(),
});

export const measurementPreviewListDto = z.object({
  measurements: measurementPreviewDto.array(),
});

export class MeasurementPreviewDto extends createZodDto(
  measurementPreviewDto,
) {}

export class MeasurementPreviewListDto extends createZodDto(
  measurementPreviewListDto,
) {}
